export enum DrawerState {
  Closed,
  UploadingState,
  ErrorState,
  EditGeckoOrganization,
  EditGeckoSite,
  EditGeckoUnit,
  EditGeckoComponent,
  EditGeckoInspection,
  ImportGeckoInspection,
  TriggerRAUTGdriveRolodexSync,
  UploadFile,
  UploadHHUTFile,
  CreateSystem,
  ImportSymbol,
}
